import React from "react";
import { UserAvatar } from "../userAvatar/UserAvatar";
import { TCText } from "../TCText/TCText";
import { Colors } from "../../utils/colors";
import { Player } from "../../apis/types";
import { useCourtBooking } from "../../context/courtBookingContext";
import { observer } from "mobx-react-lite";
import { formatAmount } from "../../utils/utils";
import { usePaymentStore } from "../../stores/StoreContext";
import LoadingSpinner from "../loadingSpinner/LoadingSpinner";
import "./PlayerToPayDetail.css";

type props = {
  player: Player;
};

export const PlayerToPayDetailOld: React.FC<props> = observer(({ player }) => {
  const { userModel } = useCourtBooking();
  const paymentStore = usePaymentStore();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: 12,
      }}>
      <UserAvatar
        size={32}
        nameStyle={{ fontSize: 12 }}
        avatar={{ name: player.name, image: player.userImageUrl }}
      />
      <div>
        <TCText
          style={{ fontWeight: 600, fontSize: 12, color: Colors.green }}
          value={
            userModel?.userId === player.userId.toString() ? "You" : player.name
          }
        />
        <div
          style={{
            flexDirection: "row",
            display: "flex",
            alignItems: paymentStore.isPlayerPricesListLoading
              ? "center"
              : "baseline",
            gap: 5,
            marginTop: -3,
          }}>
          <TCText
            style={{ fontWeight: 500, fontSize: 10, color: Colors.grey }}
            value="Total:"
          />
          {paymentStore.isPlayerPricesListLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}>
              <LoadingSpinner
                loading
                className="small-spinner-border custom-spinner-color"
              />
            </div>
          ) : (
            <TCText
              style={{ fontWeight: 600, fontSize: 14, color: Colors.green }}
              value={`$${formatAmount(paymentStore.getPlayerAmount(player))}`}
            />
          )}
        </div>
      </div>
    </div>
  );
});
